import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Home from './pages/Home';
import Platform from './pages/Platform';
import UseCases from './pages/UseCases';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogPost from './components/BlogPost';
import Company from './pages/Company';
import SecurityStory from './components/Features/SecurityStory';
import DataDetectionResponse from './pages/UseCases/DataDetectionResponse';
import DataDiscoveryAndClassification from './pages/UseCases/DataDiscoveryAndClassification';
import DataCompliance from './pages/UseCases/DataCompliance';
import DataGovernance from './pages/UseCases/DataGovernance';
import AncileGRC from './pages/UseCases/AncileGRC';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Router>
      <MainLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/platform" element={<Platform />} />
          <Route path="/use-cases" element={<UseCases />} />
          <Route path="/use-cases/data-discovery-and-classification" element={<DataDiscoveryAndClassification />} />
          <Route path="/use-cases/data-compliance" element={<DataCompliance />} />
          <Route path="/use-cases/data-detection-response" element={<DataDetectionResponse />} />
          <Route path="/use-cases/data-governance" element={<DataGovernance />} />
          <Route path="/use-cases/ancile-grc" element={<AncileGRC />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/company" element={<Company />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/security-story" element={<SecurityStory />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </MainLayout>
    </Router>
  );
}

export default App; 